import { getEnvironment, isDevelopment, isProduction } from '@booking/utils/configs'

import * as Sentry from '@sentry/nuxt'
import { version } from './package.json'

Sentry.init({
  dsn: 'https://aedad2b799ef1e4236d0727f830c81fa@sentry.cue.onl/4',
  // Sentry drops release names with '/', so not the package name @cue/subclient
  release: `subclient@${version}`,
  enabled: !isDevelopment(),
  environment: getEnvironment(),
  maxValueLength: 10000,
  normalizeDepth: 5,
  tracesSampleRate: isProduction() ? 0.1 : 1.0,
  profileSessionSampleRate: isProduction() ? 0.1 : 1.0,
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 0,
})
